// @ts-expect-error virtual module provided by vite-plugin-pwa
import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function PWAUpdatePrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration: ServiceWorkerRegistration | undefined) {
      console.log('SW Registered:', registration);
    },
    onRegisterError(error: unknown) {
      console.log('SW registration error', error);
    },
  });

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  const clearLegacyLeafletCaches = async () => {
    if (!("caches" in window)) return;
    const cacheNames = await caches.keys();
    const leafletCaches = cacheNames.filter((name) =>
      name.toLowerCase().includes("leaflet")
      || name.toLowerCase().includes("markercluster")
      || name.toLowerCase().includes("leaflet-draw")
    );
    await Promise.all(leafletCaches.map((name) => caches.delete(name)));
  };

  const handleUpdate = async () => {
    await clearLegacyLeafletCaches();
    await updateServiceWorker(true);
  };

  if (!offlineReady && !needRefresh) {
    return null;
  }

  return (
    <Card className="fixed bottom-4 right-4 z-50 w-80 shadow-lg">
      <CardHeader>
        <CardTitle>
          {offlineReady ? 'Приложение готово к работе offline' : 'Доступно обновление'}
        </CardTitle>
        <CardDescription>
          {offlineReady
            ? 'Приложение теперь может работать без интернета'
            : 'Доступна новая версия приложения. Нажмите "Обновить" для применения изменений.'}
        </CardDescription>
      </CardHeader>
      <CardContent className="flex gap-2">
        {needRefresh && (
          <Button onClick={() => void handleUpdate()}>
            Обновить
          </Button>
        )}
        <Button variant="outline" onClick={close}>
          Закрыть
        </Button>
      </CardContent>
    </Card>
  );
}

